import { render, staticRenderFns } from "./UserAccessObject.vue?vue&type=template&id=47537856&lang=pug"
import script from "./UserAccessObject.vue?vue&type=script&lang=js"
export * from "./UserAccessObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47537856')) {
      api.createRecord('47537856', component.options)
    } else {
      api.reload('47537856', component.options)
    }
    module.hot.accept("./UserAccessObject.vue?vue&type=template&id=47537856&lang=pug", function () {
      api.rerender('47537856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tableau/UserAccessObject.vue"
export default component.exports